// extracted by mini-css-extract-plugin
export default {"inputs":"c3zXJJk0","alert":"axZAIpwF","consent":"gTfyZtw6","checkbox":"KIgPveRN","consentText":"cd_aTxX5","actions":"oH42tCbk"};